import React, { createContext, useEffect, useReducer } from 'react'

export const GlobalContext = createContext()

const initialState = {
  transactions: JSON.parse(localStorage.getItem('transactions')) || [],
}

function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return { ...state, transactions: [action.payload, ...state.transactions] }
    case 'DELETE':
      return {
        ...state,
        transactions: state.transactions.filter((t) => t.id !== action.payload),
      }
    default:
      return state
  }
}

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    localStorage.setItem('transactions', JSON.stringify(state.transactions))
  }, [state.transactions])
  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  )
}
